import { gql } from '@apollo/client';
import list from './List';
import create from './Create';
import show from './Show';

export default {
  name: 'ProfessionalSpecialties',
  inputShow: gql`
    query professionalSpecialties($input: ProfessionalSpecialtyQueryInput) {
      professionalSpecialties(input: $input) {
        id
        __typename
      }
    }
  `,
  list,
  show,
  create,
  options: {
    group: 'Misc',
    label: 'Professional Specialties',
  },
};
